module.exports = __webpack_public_path__ + "static/img/xlcp.14890ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xlcp.png
// module id = aUiS
// module chunks = 1